var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 5a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h20zm-1 2H6v1h18V7z",
    fill: "#272528"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9a1 1 0 011-1h22a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V9zm2 1v14h20V10H6z",
    fill: "#272528"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15.802v2.396c0 .443.363.802.81.802h2.38c.447 0 .81-.36.81-.802v-2.396a.806.806 0 00-.81-.802h-2.38c-.447 0-.81.36-.81.802z",
    fill: "#FF4A4A"
  })));
}

export default SvgWallet;